module.exports = __webpack_public_path__ + "static/img/17.877f6872.png";